import { useTheme } from '@emotion/react';
import { capitalize, CircularProgress, Grid, useMediaQuery } from '@mui/material';
import { useConfig } from 'dynamic-configuration/configContext';
import { Form, FormikProvider, useFormik } from 'formik';
import React from 'react'
import { useNavigate } from 'react-router-dom';
import CustomInputField from 'ui-components/formik/CustomInputField';
import { adminDefaultPermissions, convertToPermissionOnly, currencyInputProps, handleFormSubmit } from 'utils';
import { FetchAllCountriesWithPhoneCodes } from 'api/utils';
import Cookies from 'js-cookie';
import { Primary, Secondary } from 'ui-components/Buttons';
import * as Yup from "yup";
import { FetchPermissionsTemplate } from 'api/permission';
import { ClaimInvestorProfile, SavePersonalInfo } from 'api/profile';
import { useToast } from 'context/ToastContext';

const titles = [
    {
        value: "Mr.",
        label: "Mr.",
    },
    {
        value: "Mrs.",
        label: "Mrs.",
    },
    {
        value: "Ms.",
        label: "Ms.",
    },
    {
        value: "Dr.",
        label: "Dr.",
    },
    {
        value: "Prof.",
        label: "Prof.",
    },
    {
        value: "CA",
        label: "CA",
    },
];

const PersonalDetails = ({ investor_type, handleClose }) => {
    const { addToast } = useToast()
    const { mutateAsync: createCollaborator, isLoading: isCreatingCollaborator } = ClaimInvestorProfile()
    const {
        mutateAsync: SavePersonalInfoAsync,
        status: savePersonalInfoStatus,
        error: savePersonalInfoError,
        isLoading: isUpdatingsavePersonalInfo,
        data: savePersonalInfoResponse,
    } = SavePersonalInfo();
    const investor_id = Cookies.get("X-ADMIN-TEMP-ID") || null;
    const {
        data: permissions_template,
        isLoading: isLoadingPermissionsTemplate,
        refetch: refetchPermissionsTemplate
    } = FetchPermissionsTemplate();
    const { data: countriesWithPhoneCodes, isRefetching: isRefetchingCountriesPC, isLoading: isLoadingCountriesPC, refetch: refetchCountriesPC } = FetchAllCountriesWithPhoneCodes({})
    const shiftSteps = investor_type ? String(investor_type)?.toLowerCase()?.includes("angel") : true;
    const validationSchema = Yup.object({
        first_name: Yup.string().required("First name is required"),
        last_name: Yup.string().required("Last name is required"),
    })
    const formik = useFormik({
        enableReinitialize: true,
        validationSchema: validationSchema,
        initialValues: {
            first_name: "",
            last_name: "",
            investor_id,
            user_role_type: "admin",
            // permission: {
            //     profile: {
            //         "view": true,
            //         "edit": true
            //     }
            // }
        },
        onSubmit: async (values, { setSubmitting }) => {
            // console.log(values);
            function removeSettingsKey(obj) {
                const { settings, ...rest } = obj;
                return rest;
            }

            const payload = {
                ...values,
                permission: {
                    ...removeSettingsKey(convertToPermissionOnly(adminDefaultPermissions({ permissionsTemplate: permissions_template })))
                }
            }

            createCollaborator(payload, {
                onSuccess: (successResponse) => {
                    // console.log(successResponse?.data, "success")
                    SavePersonalInfoAsync({
                        investor_id,
                        is_profile_completed: true
                    }, {
                        onSuccess: () => {
                            // addToast(successResponse?.data?.message, "success");
                            Cookies.set("X-ADMIN-ID", investor_id);
                            Cookies.set("is_profile_complete", true);
                            Cookies.remove("X-ADMIN-TEMP-ID");
                            const pathname = Cookies.get("pathname") || "/";
                            if (pathname) {
                                navigate(pathname, { replace: true });
                                Cookies.remove("pathname");
                            } else {
                                navigate("/profile", { replace: true });
                            }
                        }
                    }).catch(err => {

                    });
                },
                onError: (errorResponse) => {
                    // console.log(errorResponse?.data, "success")
                    addToast(errorResponse?.data?.message, "error")
                }
            })
        }
    });
    const { config } = useConfig()
    const theme = useTheme();
    const navigate = useNavigate();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'))
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
    const isTablet = useMediaQuery(theme.breakpoints.up('sm'))
    return (
        <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
                <Grid container xs={12} gap={0} marginTop={0} display={"flex"} alignItems={"flex-start"} alignContent={"flex-start"} justifyContent={"space-between"}>
                    {/* <Grid item xs={12}>
                        <CustomHeaderIcon customIcon={personalInformationImage} />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography variant='title' sx={{ fontSize: { xs: "1.5rem", md: "1.75rem" } }} marginTop={1} textAlign={{ xs: "center", md: "start" }} position={"relative"}>
                            
                            Contact Information
                        </Typography>
                    </Grid>
                    <Grid item xs={12}
                        marginBlock={1}
                        marginBottom={2}
                        marginTop={1}
                    >
                        <Typography
                            color="gray"
                            variant="bodyTextRegular"
                            textAlign={{ xs: "center", md: "start" }}
                        >
                            Provide your contact information
                        </Typography>
                    </Grid> */}
                    {/* <Grid item container xs={12} display={"flex"} gap={0} justifyContent={"space-between"} flexDirection={"row"}>
                        <CustomLabel>{config?.validationFields?.title?.label}  {formik.errors.title && formik.touched.title && (
                            <CustomValidationText value={formik.errors.title} />
                        )}</CustomLabel>
                        <Grid
                            display={"flex"}
                            flexWrap={"wrap"}
                            justifyContent={"space-between"}
                            item
                            container
                            xs={12}
                            gap={{ xs: 0.5, sm: 1, md: 2 }}
                            mb={2}
                        >
                            {titles?.map((title, index) => {
                                return (
                                    <Grid
                                        role={"button"}
                                        item
                                        // xs={12}
                                        xs={3.8}
                                        sm={1.65}
                                        md={1.6}
                                        lg={1.65}

                                        onClick={() => {
                                            formik.setFieldValue(
                                                "title",
                                                title?.value
                                            );
                                        }}
                                        sx={{
                                            background:
                                                formik.values.title ==
                                                    title?.value
                                                    ? theme?.palette?.customColors?.y50
                                                    : theme?.palette?.customColors?.whiteBG,
                                            padding: "12px 16px",
                                            height: 55,
                                            borderRadius: "8px",
                                            display: "grid",
                                            placeItems: "center",
                                            border: `1px solid ${formik.values.title ==
                                                title?.value
                                                ? theme?.palette?.customColors?.y300
                                                : theme?.palette?.customColors?.g75
                                                }`,
                                            boxShadow: "0px 1px 2px 0px #1018280D",
                                            cursor: "pointer",
                                        }}
                                    >
                                        <Typography
                                            variant="subtitle2"
                                            color={theme.palette.customColors.g200}
                                            fontSize="0.875rem"
                                        >
                                            {title?.value}
                                        </Typography>
                                    </Grid>
                                );
                            })}
                        </Grid>
                        {formik.values.title === "Other" && <Grid item xs={12} display={"flex"} gap={0} marginTop={2}>
                            <CustomInputField value={formik.values.title} name="title" label={"ENTER REFERRER NAME"} placeholder="Enter referrer name" onChange={(e) => formik.setFieldValue("title", e.target.value?.charAt(0)?.toUpperCase() + e.target.value?.slice(1))} />
                        </Grid>}
                    </Grid> */}
                    <Grid height={"min-content"} item xs={12} sm={12} md={12} lg={12}>
                        <CustomInputField name={`first_name`} label={config?.validationFields?.first_name?.label} onChange={(e) => { formik.setFieldValue('first_name', capitalize(e.target.value)?.trimStart()) }} fullWidth />
                    </Grid>
                    <Grid height={"min-content"} item xs={12} sm={12} md={12} lg={12}>
                        <CustomInputField name={`last_name`} label={config?.validationFields?.last_name?.label} onChange={(e) => { formik.setFieldValue('last_name', capitalize(e.target.value)?.trimStart()) }} fullWidth />
                    </Grid>
                    <Grid height={"min-content"} item xs={12} sm={12} md={12} lg={12}>
                        {/* <DialogActions sx={{ justifyContent: 'center'
                        // , padding: '1rem 1.5rem' 
                        }}> */}
                        {/* <Secondary onClick={handleClose} fullWidth sx={{ borderWidth: "1px", padding: '0.75rem 1.25rem', fontSize: '1rem', marginRight: '1rem', backgroundColor: theme.palette.customColors.grey }}>
                                Cancel
                            </Secondary> */}
                        <Primary disabled={isCreatingCollaborator} onClick={(e) => {
                            handleFormSubmit(e, formik)
                        }} fullWidth sx={{ padding: '0.75rem 1.25rem', height: "52px", fontSize: '1rem', backgroundColor: theme.palette.customColors.red }}>
                            {isCreatingCollaborator ? <CircularProgress size={"1.5rem"} /> : "Activate"}
                        </Primary>
                        {/* </DialogActions> */}
                    </Grid>
                </Grid>
            </Form>
        </FormikProvider>
    )
}

export default PersonalDetails